module.exports = __webpack_public_path__ + "static/media/AJ.502a494c.png";